import { AdminSidebar } from '../../components/admin/AdminSidebar';
import { AdminContentLab } from '../AdminContentLab';

export function AdminContentLabWrapper() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 overflow-x-hidden">
          <AdminContentLab />
        </main>
      </div>
    </div>
  );
}
